import {
    useState
    , useEffect
    , useMemo
} from 'react';

import { ROUTE_WORKFLOW_TASKS } from '../routes/Routes';
import { Button, DataGrid } from 'devextreme-react';
import { LoadingPanel } from '../components/LoadingPanel';
import { Column, FilterRow, KeyboardNavigation, Pager, Paging, SearchPanel, Toolbar, Item } from 'devextreme-react/data-grid';
import CustomPreparedHeaderCell from '../components/CustomPreparedHeaderCell';
import { allowedPageSizes } from '../components/GlobalDataGridConfigurations';
import { useNavigate } from "react-router-dom";
import { getWorkflowStatusCodeForUser, canEditWorkflowTask } from './tcmWorkflowRules';
import { getWorkflowTasksByStatus } from './tcmWorkflowService';
import { useAuth } from '../hooks/useAuth';

const WorkflowTaskList = () => {
    const [data, setData] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const { user } = useAuth();
    console.log('user: ', user);
    const statusCode = useMemo(() => {
        console.log('status code', getWorkflowStatusCodeForUser(user))
        return getWorkflowStatusCodeForUser(user);
    }, [user]);

    useEffect(() => {
        document.title = ROUTE_WORKFLOW_TASKS.title;

        if (!statusCode) {
            setErrorMessage('You do not currently have access to workflow tasks.');
            return;
        }

        console.log('retrieving data in effect')
        retrieveData();
    }, [statusCode]);

    const retrieveData = async () => {
        setLoading(true);
        setErrorMessage(null);

        console.log('retrieving data')
        try {
            const result = await getWorkflowTasksByStatus(statusCode);
            const { Success, Errors, Message } = result;

            console.log('workflow tasks.1: ', Message)
            if (Success) {
                setData(Message ?? []);
                console.log('workflow tasks: ', Message)
            } else {
                setData([]);
                setErrorMessage(Errors?.[0]?.Message ?? 'Unable to load workflow tasks.');
            }
        } catch {
            setData([]);
            setErrorMessage('An unexpected error occurred while loading workflow tasks.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div id='workflow-list'>
            <h1 style={{ color: "#06152B" }}>Workflow Task List</h1>
            {loading
                && <LoadingPanel location={{ of: '#workflow-list' }} message="Loading Workflow Tasks..." />
            }
            <DataGrid
                columnAutoWidth={true}
                dataSource={data}
                onCellPrepared={CustomPreparedHeaderCell}
                showBorders={true}
                showRowLines={true}
                rowAlternationEnabled={true}
                noDataText='No Workflow tasks found'
            >
                <FilterRow visible={true} />
                <KeyboardNavigation enabled={true} />
                <Paging defaultPageSize={10} />
                <Pager
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                />
                <SearchPanel visible placeholder='Search...' highlightCaseSensitive />
                <Toolbar>
                    <Item name="searchPanel" locateInMenu="auto" />
                    <Item location='after'>
                        <Button text='Home' icon='home' stylingMode='outlined' type='normal' onClick={() => navigate('/')} />
                    </Item>
                </Toolbar>
                <Column
                    dataField="Id"
                    caption="Cost Estimate ID"
                    cellRender={(cellData) => {
                        console.log('cell data: ', cellData)
                        return (
                            <a
                                href="#"
                                style={{ fontWeight: 'bold', color: '#005288' }}
                                onClick={(e) => {
                                    e.preventDefault();
                                    navigate(`/tcm-Projects/${cellData?.data?.ProjectId}`);
                                }}
                            >
                                View: {cellData.value}
                            </a>
                        );
                    }}
                    sortOrder="desc"
                    fixed={true}
                    fixedPosition="left"
                />
                <Column
                    dataField="ProjectId"
                    caption="Project ID"
                />
                <Column
                    dataField="Title"
                    caption="Title"
                />
                <Column
                    dataField="TCMCostEstimateStatus.Name"
                    caption="Cost Estimate Status"
                />
                <Column
                    dataField="Comments"
                    caption="Comments"
                    cellRender={(cellData) => (
                        <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                            {cellData.value}
                        </div>)
                    }
                />
            </DataGrid>
        </div>
    )
}

export default WorkflowTaskList;
